module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Menu', {
    staticClass: "layout-menu-style",
    attrs: {
      "open-names": ['1', '2', '3']
    }
  }, [_c('Submenu', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-people"
    }
  }), _vm._v("\n        代理商\n      ")], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "orderSummary",
      "to": "/order-summary"
    }
  }, [_vm._v("消费统计")])], 2), _vm._v(" "), (_vm.vendorInfo.level === 0) ? _c('Submenu', {
    attrs: {
      "name": "data_monitor"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("\n        数据监控\n      ")], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "data_monitor_device_data",
      "to": "/device-summary-data"
    }
  }, [_vm._v("设备数据汇总")])], 2) : _vm._e(), _vm._v(" "), (_vm.vendorInfo.level === 0) ? _c('Submenu', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("\n        平台数据\n      ")], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "2-3",
      "to": "/feedback"
    }
  }, [_vm._v("反馈管理")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "moneySummary",
      "to": "/money-summary"
    }
  }, [_vm._v("财务报表")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "withdraw",
      "to": "/transfer-mgnt"
    }
  }, [_vm._v("提现管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.vendorInfo.level === 0) ? _c('Submenu', {
    attrs: {
      "name": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-settings"
    }
  }), _vm._v("\n        平台配置\n      ")], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "3-1",
      "to": "/device"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "3-2",
      "to": "/service-package"
    }
  }, [_vm._v("氧疗套餐配置")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "vendorMgnt",
      "to": "/vendor"
    }
  }, [_vm._v("代理商管理")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "3-4",
      "to": "/recharge-package"
    }
  }, [_vm._v("充值套餐配置")]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "3-5",
      "to": "/brand"
    }
  }, [_vm._v("品牌管理")])], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7beb4f74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftMenu.vue
// module id = 96
// module chunks = 14